<template>
    <div id="send-sms-postacell">
        <div class="header">
            <div class="title">Send Sms</div>
            <div class="subtitle">Send sms to your customers</div>
        </div>
        <SendSmsInputV2 :default-phone-number="phoneNumber" @sendSMS="sendSMS" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import SendSmsInputV2 from "./SendSmsInput.vue";
import { generateUUID } from "../../../../../../utils/session";
import { sendSocketMessage } from "../../../../../../utils/socketStream";

export default {
    name: "SendSmsPostacell",
    components: {
        SendSmsInputV2,
    },
    data() {
        return {
            phoneNumber: "",
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    methods: {
        async sendSMS({ text, channelId, senderId, number }) {
            const payload = {
                siteId: this.site._id,
                channelId,
                channelType: "sms-postacell",
                number,
                message: text,
                senderId,
                title: null,
                customMessageId: generateUUID(),
            };
            sendSocketMessage("sms send-single", payload);
        },
    },
};
</script>
<style scoped lang="scss">
#send-sms-postacell {
    .header {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            padding-left: 5px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
